<template>
    <div class="unit-info-prometheus__wrap">

        <div class="unit-info-prometheus__header page-block">
            <div class="unit-info-prometheus__box" style="flex-direction: column">
                <div class="unit-info-prometheus__box-item flex justify-content-space-between">
                    <div class="flex align-items-canter flex-gap-10">
                        <span class="unit-info-prometheus__icon">
                            <SvgIcon name="car" class="icon"/>
                        </span>
                        <div class="unit-info-prometheus__title">{{unit?.name}}:</div>
                    </div>
                    <button class="button button_view_base button_theme_white unit-info-prometheus-edit-button"
                            :disabled="!isUnitFullLoad"
                            @click="setRoute.unitEdit($route, $router, unitId)"
                    >
                        <span>
                            <SvgIcon name="common__edit" class="icon"/>
                        </span>
                        <span>
                            {{$t('actions.edit')}}
                        </span>
                    </button>
                </div>
                <UnitInfo_indicators
                    class="unit-info-prometheus__box-item flex align-items-canter flex-gap-10"
                    :unitId="unitId"
                    :indicators="pageParams.indicators"
                />
            </div>
            <div class="unit-info-prometheus__box unit-info-prometheus__address">
                <UnitInfo__address :unitId="unitId"/>
            </div>
        </div>

        <UnitInfo__sensors
            class="unit-info-prometheus__sensors page-block"
            :sensors="pageParams.sensors"
            :hideSensorByValue="true"
            :unitId="unitId"
        />

        <!--    border    -->
        <div class="default-border-bottom page-block"></div>

        <TabsControlByRoute class="page-block" :list="pageParams.menuList"/>

        <div class="default-border-bottom page-block"></div>

        <div id="sectionInfoByPage" class="page-block"></div>
    </div>
</template>

<script>
import consts from "@/consts";
import {mapGetters} from "vuex";
import UnitInfo_indicators from "@/components/units/info/indicators/UnitInfo_indicators.vue";
import UnitInfo__address from "@/components/units/info/UnitInfo__address.vue";
import TabsControlByRoute from "@/components/_base/TabsControlByRoute.vue";
import UnitInfo__sensors from "@/components/units/info/UnitInfo__sensors.vue";
import unitLmsgMixin from "@/mixins/unitLmsgMixin";

export default {
    setup() {
        return {
            defaultAccordionInfo: ['sensors'],
        }
    },
    name: "UnitInfo_content_base",
    mixins: [unitLmsgMixin],
    inject: ['fnAddPageClass','fnRemovePageClass'],
    props: {
        unitId: Number,
    },
    components: {
        TabsControlByRoute,
        UnitInfo__address,
        UnitInfo_indicators,
        UnitInfo__sensors,
    },
    data() {
        return {
            activeType: 'video',
            component: '',
            components: [
                {id: '', name: ''}
            ],
        }
    },
    computed: {
        ...mapGetters([
            "getAppUser",
            "getWindowWidth",
            "isUnitsFullLoad",
            "getUnitsIdsIsFullLoad",
            "isXRoutesFullLoad",
            "isXRoutesCalculatedFullLoad",
        ]),
        unitsIdsIsFullLoad() {
            return new Set(this.getUnitsIdsIsFullLoad)
        },
        isUnitFullLoad() {
            return this.isUnitsFullLoad || !!this.unitsIdsIsFullLoad.has(this.unitId)
        },
        routesList() {
            let list = [
                {
                    id: 'info',
                    name: this.$t('Unit.menu.Info'),
                    icon: 'common__info',
                    route_name: consts.routerNames?.units?.type[this.routeTemplate]?.info,
                    setRoute: () => this.setRoute.unitId(this.$route, this.$router, this.unitId),
                },
                {
                    id: 'truck',
                    name: this.$t('Unit.menu.Track'),
                    icon: 'build-track',
                    route_name: consts.routerNames.units.track.main,
                    setRoute: () => this.setRoute.track(this.$route, this.$router, this.unitId),
                },
            ];
            if (this.getAppUser?.is_xroute) {
                list.push({
                    id: 'xroute',
                    name: this.$t('Unit.menu.xRoute'),
                    icon: 'xRoute',
                    route_name: consts.routerNames.units.xroute.main,
                    disabled: !this.isUnitFullLoad,
                    hide: !this.$consts.xRoute.availableForUnitTypes.includes(this.unitType),
                    setRoute: () => this.setRoute.unitXRoute(this.$route, this.$router, this.unitId),
                });
            }
            return list;
        },
        menuList() {
            return this.routesList.filter(o => !o.hide)
        },
        pageParamsByUnitType() {
            //ToDo fix
            let defautlIndicators = ['connection', 'movement', 'ignition'];
            if(this.hasVideo) {
                defautlIndicators.push('camera')
            }
            return {
                default: {
                    menuList: this.menuList.filter(item => item.id === 'info'),
                    indicators: ['connection']
                },
                xvision : {
                    menuList: this.menuList,
                    indicators: [...defautlIndicators],
                    sensors: ['last_message', 'imei', 'speed', 'brand', 'satelletes', 'year'],
                },
                xtrack : {
                    menuList: this.menuList,
                    indicators: [...defautlIndicators],
                    sensors: ['last_message', 'imei', 'speed', 'brand', 'satelletes', 'year'],
                },
                xcool : {
                    menuList: this.menuList,
                    indicators: [...defautlIndicators],
                    sensors: ['last_message', 'imei', 'speed', 'brand', 'satelletes', 'year'],
                },
                xpower : {
                    menuList: this.menuList,
                    indicators: [...defautlIndicators],
                    sensors: ['last_message', 'imei', 'speed', 'brand', 'satelletes', 'year'],
                },
                xcargo : {
                    menuList: this.menuList,
                    indicators: [...defautlIndicators],
                    sensors: ['last_message', 'imei', 'speed', 'brand', 'satelletes', 'year'],
                },
                xlink : {
                    menuList: this.menuList,
                    indicators: [...defautlIndicators],
                    sensors: ['last_message', 'imei', 'speed', 'brand', 'satelletes', 'year'],
                },
                pro_cargo_vision : {
                    menuList: this.menuList,
                    indicators: [...defautlIndicators],
                    sensors: ['last_message', 'imei', 'speed', 'brand', 'satelletes', 'year'],
                },
                xbles : {
                    menuList: this.menuList
                        .filter(item => this.isStationaryObj ? item.id !== 'truck' : true),
                    indicators: [...defautlIndicators],
                    sensors: ['last_message', 'imei', 'speed', 'brand', 'satelletes', 'year'],
                },
                obd : {
                    menuList: this.menuList,
                    indicators: [...defautlIndicators],
                    sensors: ['last_message', 'imei', 'speed', 'brand', 'satelletes', 'year'],
                },
                m2m : {
                    menuList: this.menuList,
                    indicators: [...defautlIndicators],
                    sensors: ['last_message', 'imei', 'speed', 'brand', 'satelletes', 'year'],
                },
                m2m_chassis : {
                    menuList: this.menuList,
                    indicators: [...defautlIndicators],
                    sensors: ['last_message', 'imei', 'speed', 'brand', 'satelletes', 'year'],
                },
                sensors : {
                    menuList: this.menuList,
                    indicators: [...defautlIndicators],
                    sensors: ['last_message', 'imei', 'speed', 'brand', 'satelletes', 'year'],
                },
            }
        },
        hideInfoUnit() {
            return this.routeMeta.hideInfoUnit
        },
        pageParams() {
            return this.pageParamsByUnitType[this.routeTemplate] || this.pageParamsByUnitType.default
        },
    },
}
</script>

<style lang="scss">
@import "@/scss/02-components/unit-info-prometheus.scss";
</style>